import axios from 'axios';
import router from '../router';
import { Loading, Message, MessageBox } from 'element-ui';

const axiosInstance = axios.create({
    timeout: 60000,
});

let isRefreshing = false;
let requests = []; //存储因token过期而挂起的请求

//请求拦截器
axiosInstance.interceptors.request.use(
    config => {
        if (localStorage.getItem('token')) {
            config.headers.Authorization = localStorage.getItem('token');
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

//响应拦截器
axiosInstance.interceptors.response.use(
    async response => {
        if (response.data.status === 204) {
            Message({
                type: 'warning',
                message: '登录失效，请重新登录',
                onClose: () => {
                    // localStorage.clear();
                    // window.location.href = '/#/';
                },
            });
        }
        if (response.data.status === 401) {
            const { config } = response;
            if (isRefreshing) {
                return new Promise(resolve => {
                    requests.push(() => resolve(axiosInstance(config)));
                });
            }
            isRefreshing = true;

            try {
                const token = await refreshToken();
                config.headers['Authorization'] = token;
                requests.forEach(cb => cb());
                requests = [];
                return axiosInstance(config);
            } catch (error) {
                // setTimeout(() => {
                //     localStorage.clear();
                //     router.push({
                //         path: '/',
                //     });
                // }, 2000);
                return Promise.reject(error);
            } finally {
                isRefreshing = false;
            }
        }
        return response.data;
    },
    error => {
        return Promise.reject(error);
    }
);

const get = (url, param = {}) => {
    return axiosInstance.get(url, { params: param });
};

const post = (url, formdata = {}, config = {}) => {
    return axiosInstance.post(url, formdata, config);
};

const refreshToken = async () => {
    try {
        const { code, msg, data } = await post('/login/refresh', {});
        if (code === 200) {
            console.log('data', data);
            localStorage.setItem('expire_time', data.expire_time);
            localStorage.setItem('refresh', data.refresh_expire_time);
            localStorage.setItem('token', data.token);
            return data.token;
        }
    } catch (error) {
        return Promise.reject(error);
    }
};

export { get, post, refreshToken };
